import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, Phone, X } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "./content";
import { scrollToId } from "../../lib/lenis";

const LINKS = [
  ["program", "Program"],
  ["discounts", "Discounts"],
  ["stacker", "Discount Stacker"],
  ["faq", "FAQ"],
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-asphalt/70 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <button onClick={() => go("top")} data-testid="header-logo-btn" aria-label="Back to top">
          <Logo />
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-${id}-link`} className="link-underline font-body text-sm text-mist transition-colors hover:text-bone">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={CONTACT.tel} data-testid="header-call-btn" className="group hidden items-center gap-2 rounded-full bg-lane px-5 py-2.5 font-body text-sm font-bold text-asphalt transition-transform duration-300 hover:-translate-y-0.5 sm:flex">
            <Phone className="h-4 w-4 transition-transform duration-300 group-hover:rotate-12" /> {CONTACT.phone}
          </a>
          <button onClick={() => setOpen((v) => !v)} className="rounded-full border border-white/15 p-2.5 text-bone lg:hidden" data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t border-white/10 bg-asphalt lg:hidden"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col px-5 py-4">
              {LINKS.map(([id, label]) => (
                <button key={id} onClick={() => go(id)} data-testid={`mobile-nav-${id}-link`} className="border-b border-white/5 py-4 text-left font-display text-3xl font-bold uppercase text-bone">
                  {label}
                </button>
              ))}
              <a href={CONTACT.tel} data-testid="mobile-call-btn" className="mt-5 flex items-center justify-center gap-2 rounded-full bg-lane py-4 font-bold text-asphalt">
                <Phone className="h-4 w-4" /> Call {CONTACT.phone}
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
